import { render } from "./BaseDepartmentListView.vue?vue&type=template&id=b7118414&scoped=true"
import script from "./BaseDepartmentListView.vue?vue&type=script&lang=js"
export * from "./BaseDepartmentListView.vue?vue&type=script&lang=js"

import "./BaseDepartmentListView.vue?vue&type=style&index=0&id=b7118414&scoped=true&lang=css"

import exportComponent from "E:\\源码\\baoxiu\\baoxiu\\VUE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7118414"]])

export default __exports__